import { render, staticRenderFns } from "./instituciones-f1-snp.vue?vue&type=template&id=0a2b97b0&scoped=true&"
import script from "./instituciones-f1-snp.component.ts?vue&type=script&lang=ts&"
export * from "./instituciones-f1-snp.component.ts?vue&type=script&lang=ts&"
import style0 from "./instituciones-f1-snp.vue?vue&type=style&index=0&id=0a2b97b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b97b0",
  null
  
)

export default component.exports